import {BaseClientNumberValidator} from './validator';

export {ClientNumberDirective} from './directive';
export {ClientNumberPipe} from './pipe';

export const CLIENT_NUMBER_VALIDATORS = [BaseClientNumberValidator];
